<template>
  <div class="content tunnel-step-4">
    <step-navbar :current-step="4"/>
    <div id="content" class="container">
      <template v-if="lock">
        <div class="modal-backdrop"></div>
        <div class="modal-popup">
          <div class="popup-shadow">
            <p>{{$t('tunnel.step4.verification')}}</p>
          </div>
        </div>
      </template>
      <div class="page">
        <div class="search--wrapper">
          <h3 v-if="bookingCount <= 1">{{ $t('step4-multi.title.singular') }}</h3>
          <h3 v-else>{{ $t('step4-multi.title.plural') }}</h3>
          <h4 v-if="bookingCount > 1" v-html="$t('step4-multi.subtitle.plural', 1, bookingCount)"></h4>
          <h4 v-else v-html="$t('step4-multi.subtitle.singular', 1, bookingCount)"></h4>
          <div class="paiement-info" v-if="bookingCount > 1">
            <p>{{ $t('step4-multi.paymentInfos.0') }}</p>
            <p>{{ $t('step4-multi.paymentInfos.1') }}</p>
          </div>
        </div>
        <div class="payment-wrapper">
          <step4-booking :booking="booking" v-for="(booking, index) in bookings" :key="booking.id" v-on:lock="handleBookingLock" :index="index+1" :total="bookingCount"></step4-booking>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import Step4Booking from "./step4-multi/step4-booking";
import StepNavbar from './step-navbar';

export default {
  name: 'step4-multi',
  components: {
    Step4Booking,
    StepNavbar
  },
  async mounted () {
    window.onbeforeunload = () => true;
    await this.$store.dispatch('shoppingCart/init');
    await this.$store.dispatch('shoppingCart/booking/personal/reset');
  },
  beforeDestroy() {
    window.onbeforeunload = null;
  },
  data() {
    return {
      lock: false,
    }
  },
  computed: mapState({
    bookings: s => s.shoppingCart.bookings,
    bookingCount: s => s.shoppingCart.bookings.length,
    shoppingCartLoading: s => s.shoppingCartLoading,
  }),
  methods: {
    handleBookingLock(value) {
      this.lock = value;
    }
  },
  watch: {
    async bookingCount () {
      if (this.lock) return;
      if (this.shoppingCartLoading) return;
      if (this.bookingCount === 0) {
        await this.$router.push({name: 'places'});
      }
    },
  }
};
</script>

<style scoped>
#content h3 {
  margin: 0;
  width: 100%;
}

#content h4 {
  margin: 0 0 12px 0;
  width: 100%;
}
.CGCV {
  text-align: center;
  margin: 20px auto;
  display: block;
  width: fit-content;
}
.paiement-info p {
  margin: .5em 0;
}
.paiement-info {
  margin: 0 0 1em 0;
}

</style>



// WEBPACK FOOTER //
// src/pages/tunnel/step4-multi.vue